export default {
  "root": "_root_dv0g6_1",
  "--contained": "_--contained_dv0g6_1",
  "--position-center": "_--position-center_dv0g6_1",
  "--active": "_--active_dv0g6_1",
  "--position-bottom": "_--position-bottom_dv0g6_1",
  "--position-start": "_--position-start_dv0g6_1",
  "--position-end": "_--position-end_dv0g6_1",
  "--position-full-screen": "_--position-full-screen_dv0g6_1",
  "--dragging": "_--dragging_dv0g6_1",
  "--overflow-visible": "_--overflow-visible_dv0g6_1",
  "--position-center--m": "_--position-center--m_dv0g6_1",
  "--position-bottom--m": "_--position-bottom--m_dv0g6_1",
  "--position-start--m": "_--position-start--m_dv0g6_1",
  "--position-end--m": "_--position-end--m_dv0g6_1",
  "--position-full-screen--m": "_--position-full-screen--m_dv0g6_1",
  "--position-center--l": "_--position-center--l_dv0g6_1",
  "--position-bottom--l": "_--position-bottom--l_dv0g6_1",
  "--position-start--l": "_--position-start--l_dv0g6_1",
  "--position-end--l": "_--position-end--l_dv0g6_1",
  "--position-full-screen--l": "_--position-full-screen--l_dv0g6_1",
  "--position-center--xl": "_--position-center--xl_dv0g6_1",
  "--position-bottom--xl": "_--position-bottom--xl_dv0g6_1",
  "--position-start--xl": "_--position-start--xl_dv0g6_1",
  "--position-end--xl": "_--position-end--xl_dv0g6_1",
  "--position-full-screen--xl": "_--position-full-screen--xl_dv0g6_1"
};import "ni:sha-256;uGa4vw5ehcI27vwgxKvpQoFidv3bO7psyxbnX8BCPoc";